import { useMemo as u, useRef as s } from "react";
import { l as n } from "./lodash-fd177a50.js";
import "./_commonjsHelpers-10dfc225.js";
function m(o, t) {
  const r = u(o, t), e = s();
  return n.isEqual(r, e.current) || (e.current = r), e.current;
}
export {
  m as default
};
